<template>
    <div>
        <div class="header page-header">
            <div>INVOICES</div>
            <p/>
        </div>
        <div class="filters-container">
            <div class="form__group">
                <label class='label--search'>From</label>
                <datepicker
                    class="input input__round input--calendar"
                    clear-button
                    v-model="filter.date_from"
                    @input="onFilterChange"
                    placeholder="Select start date"
                ></datepicker>
            </div>
            <div class="form__group">
                <label class='label--search'>To</label>
                <datepicker
                    clear-button
                    class="input input__round input--calendar"
                    v-model="filter.date_to"
                    @input="onFilterChange"
                    placeholder="Select end date"
                ></datepicker>
            </div>
            <div class="form__group">
                <label class='label--search'>Status</label>
                <Multiselect
                    class="input input__round input--dropdown input--status-search"
                    style="cursor:pointer;"
                    placeholder="Select options"
                    @input="onFilterChange"
                    v-model="filter.status"
                    :options="status_options"
                    :select-label="'✔'"
                    :deselect-label="'X'"
                    :close-on-select="false"
                    :multiple="true"
                ></Multiselect>
            </div>
            <div class="form__group">
                <label class='label--search'>Search</label>
                <Search
                    class="input input__round input--search"
                    placeholder="Search..."
                    @on-value-change="searchValueChanged"
                />
            </div>
            <div>
                <Button
                    class="btn btn__primary btn__primary--outline"
                    text="Export to excel"
                    @on-click="onExportClick"
                />
            </div>
            <div style="height: 37px;">
                <img
                    src="../../assets/agreement_button.png"
                    style="cursor: pointer;height: 37px;"
                    @click="goToCreatePage()"
                >
                <!-- <Button class="btn btn__primary" text="New Invoice" @on-click="goToCreatePage"/> -->
            </div>
        </div>
        <div class="card">
            <table class="has-links" style="width:100%">
                <col width="7%">
                <col width="10%">
                <col width="15%">
                <col width="10%">
                <col width="10%">
                <col width="5%">
                <col width="15%">
                <col width="15%">
                <tr>
                    <th @click="setSort('id')">
            <span class="column-order">
              <span>Invoice ID</span>
              <i
                  class="pg pg-chevron-up"
                  v-bind:class="{active: this.sort.value==='id'}"
                  v-if="this.sort.value === 'id' && this.sort.direction === 'asc'"
              ></i>
              <i
                  class="pg pg-chevron-down"
                  v-bind:class="{active: this.sort.value==='id'}"
                  v-else
              ></i>
            </span>
                    </th>
                    <th @click="setSort('invoice_number')">
            <span class="column-order">
              <span>Invoice Number</span>
              <i
                  class="pg pg-chevron-up"
                  v-bind:class="{active: this.sort.value==='invoice_number'}"
                  v-if="this.sort.value === 'invoice_number' && this.sort.direction === 'asc'"
              ></i>
              <i
                  class="pg pg-chevron-down"
                  v-bind:class=" {active: this.sort.value==='invoice_number'}"
                  v-else
              ></i>
            </span>
                    </th>
                    <th @click="setSort('name')">
            <span class="column-order">
              <span>Name</span>
              <i
                  class="pg pg-chevron-up"
                  v-bind:class="{active: this.sort.value==='name'}"
                  v-if="this.sort.value === 'name' && this.sort.direction === 'asc'"
              ></i>
              <i
                  class="pg pg-chevron-down"
                  v-bind:class="{active: this.sort.value==='name'}"
                  v-else
              ></i>
            </span>
                    </th>
                    <th @click="setSort('phone')">
            <span class="column-order">
              <span>Phone</span>
              <i
                  class="pg pg-chevron-up"
                  v-bind:class="{active: this.sort.value==='phone'}"
                  v-if="this.sort.value === 'phone' && this.sort.direction === 'asc'"
              ></i>
              <i
                  class="pg pg-chevron-down"
                  v-bind:class="{active: this.sort.value==='phone'}"
                  v-else
              ></i>
            </span>
                    </th>
                    <th @click="setSort('due_date')">
            <span class="column-order">
              <span>Due date</span>
              <i
                  class="pg pg-chevron-up"
                  v-bind:class="{active: this.sort.value==='due_date'}"
                  v-if="this.sort.value === 'due_date' && this.sort.direction === 'asc'"
              ></i>
              <i
                  class="pg pg-chevron-down"
                  v-bind:class="{active: this.sort.value==='due_date'}"
                  v-else
              ></i>
            </span>
                    </th>
                    <th @click="setSort('status')">
            <span class="column-order">
              <span>Status</span>
              <i
                  class="pg pg-chevron-up"
                  v-bind:class="{active: this.sort.value==='status'}"
                  v-if="this.sort.value === 'status' && this.sort.direction === 'asc'"
              ></i>
              <i
                  class="pg pg-chevron-down"
                  v-bind:class="{active: this.sort.value==='status'}"
                  v-else
              ></i>
            </span>
                    </th>
                    <th @click="setSort('created_at')">
            <span class="column-order">
              <span>Created at</span>
              <i
                  class="pg pg-chevron-up"
                  v-bind:class="{active: this.sort.value==='created_at'}"
                  v-if="this.sort.value === 'created_at' && this.sort.direction === 'asc'"
              ></i>
              <i
                  class="pg pg-chevron-down"
                  v-bind:class="{active: this.sort.value==='created_at'}"
                  v-else
              ></i>
            </span>
                    </th>
                    <th @click="setSort('updated_at')">
            <span class="column-order">
              <span>Updated at</span>
              <i
                  class="pg pg-chevron-up"
                  v-bind:class="{active: this.sort.value==='updated_at'}"
                  v-if="this.sort.value === 'updated_at' && this.sort.direction === 'asc'"
              ></i>
              <i
                  class="pg pg-chevron-down"
                  v-bind:class="{active: this.sort.value==='updated_at'}"
                  v-else
              ></i>
            </span>
                    </th>
                    <th></th>
                </tr>
                <tr
                    v-for="invoice in invoices.data"
                    :key="invoice.id"
                    class="table-row"
                    @click="goToDetails(invoice, $event)"
                >
                    <td>{{invoice.id}}</td>
                    <td>{{invoice.invoice_number}}</td>
                    <td>{{invoice.consumer_name}}</td>
                    <td>{{invoice.consumer_alias}}</td>
                    <td>{{moment(invoice.due_date).format('DD.MM.YYYY')}}</td>
                    <td>
                        <Label :status="invoice.status"
                              />
                    </td>
                    <td>{{moment(invoice.created_at).format('DD.MM.YYYY HH:MM')}}</td>
                    <td>{{moment(invoice.updated_at).format('DD.MM.YYYY HH:MM')}}</td>
                    <td>
                        <a href="#" v-if="!invoice.is_final_status" @click.prevent.stop="check(invoice)">Check
                            status</a>
                    </td>
                </tr>
            </table>
        </div>
        <div v-if="invoices.last_page && (invoices.last_page > 1)" class="paginate__wrapper">
            <paginate
                :page-count="invoices.last_page || 1"
                :prev-text="'Prev'"
                :click-handler="onPageChange"
                name="invoices"
                :next-text="'Next'"
                :first-last-button="true"
                :container-class="'paginate'"
            ></paginate>
        </div>
    </div>
</template>

<script>
    import Datepicker from "vuejs-datepicker";
    import Label from "../partials/Label";
    import Multiselect from "vue-multiselect";
    import Paginate from "vuejs-paginate";
    import Button from "../partials/Button.vue";
    import moment from "moment";
    import Search from "../partials/Search.vue";
    import * as api from "./api.js";
    import axios from "axios";
    import download from '../../helpers/download'

    export default {
        name      : "InvoicesList",
        components: {
            Datepicker,
            Button,
            Label,
            Paginate,
            Search,
            Multiselect
        },
        created   : async function () {
            this.fetchInvoices();
            document.title = "Invoices | PayGate Invoice";
        },
        methods   : {
            onExportClick     : async function () {
                let response;
                try {
                    response = await api.exportToExcel({
                        search: this.search,
                        filter: this.filter
                    });
                    let mime = response.headers['content-type'] || 'application/octet-stream';
                    download(response.data, 'file.xlsx', mime);
                } catch (e) {
                    console.log(e);
                }
            },
            setSort(sort) {
                if (this.sort.value == sort) {
                    console.log("egale");
                    if (this.sort.direction == "asc") {
                        console.log("asd");
                        this.sort.direction = "desc";
                    } else {
                        console.log("desc");
                        this.sort.direction = "asc";
                    }
                } else {
                    console.log("neegale");
                    this.sort.value = sort;
                    this.sort.direction = "asc";
                }
                this.fetchInvoices();
                console.log(this.sort);
            },
            onFilterChange() {
                this.page = 1;
                this.fetchInvoices();
            },
            goToDetails(invoice, e) {
                if (e.target.innerText !== 'Check') {
                    this.$router.push(`invoices/${invoice.id}`);
                }
            },
            goToCreatePage() {
                this.$router.push(`invoices/create`);
            },
            searchValueChanged: async function (search) {
                this.search = search;
                this.page = 1;
                this.fetchInvoices();
            },
            onPageChange      : async function (toPage) {
                this.page = toPage;
                this.fetchInvoices();
            },
            fetchInvoices     : async function () {
                this.invoices = await api.fetchInvoices({
                    search: this.search,
                    page  : this.page,
                    filter: this.filter,
                    sort  : this.sort
                });
            },
            check             : async function (invoice) {
                console.log('check: ' + invoice.id);
                axios({
                    method: 'get',
                    url   : process.env.VUE_APP_API_URL + '/check-invoice/' + invoice.id
                })
                    .then(response => {

                        this.fetchInvoices();

                    })
                    .catch(() => console.log('error occured'))
            }
        },
        data() {
            return {
                invoices      : {},
                moment        : moment,
                value         : null,
                status_options: [
                    "All",
                    "Created",
                    "Invalid",
                    "Accepted",
                    "Paid",
                    "Rejected",
                    "Expired",
                    "Canceled",
                    "Sent"
                ],
                filter        : {status: ["All"]},
                search        : "",
                page          : 1,
                sort          : {
                    value    : "created_at",
                    direction: "desc"
                }
            };
        }
    };
</script>

<style lang="scss" scoped>
    .filters-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 24px;
    }

</style>
